import { defineStore } from 'pinia'
import { LanguageCodes } from '~/enums/LanguageCodes'
import type { DottedTranslationResource, Translation, TranslationValue } from '~/types/translationTypes'

export const useTranslationStore = defineStore('translation', {
  state: (): Translation => {
    return {
      locale: LanguageCodes.English,
      data: {},
      resources: {},
    }
  },
  getters: {
    getLocale: (state: Translation) => state.locale,
    getResources: (state: Translation) => state.resources,
  },
  actions: {
    getByKey(key: string): TranslationValue {
      return this.data[key] ?? null
    },
    setByKey(key: string, value: TranslationValue): void {
      this.data[key] = value
    },
    setLocale(locale: string): void {
      this.locale = locale
    },
    setResources(resources: DottedTranslationResource): void {
      this.resources = resources
    },
    resetData(): void {
      this.data = {}
      this.resources = {}
    },
  },
})
